import { defineMessages } from "react-intl";
export default defineMessages({
  premiumAccount: {
    "id": "common.premiumAccount",
    "defaultMessage": "Premium account"
  },
  freeAccount: {
    "id": "common.freeAccount",
    "defaultMessage": "Free account"
  },
  manage: {
    "id": "common.manage",
    "defaultMessage": "Manage"
  },
  switchToPremium: {
    "id": "common.switchToPremium",
    "defaultMessage": "Switch to SmartMixin Premium"
  },
  alreadyPremium: {
    "id": "common.alreadyPremium",
    "defaultMessage": "You already have a premium account!"
  },
  freeSubscription: {
    "id": "common.freeSubscription",
    "defaultMessage": "Free premium subscription"
  },
  purchasedNetatmoPro: {
    "id": "common.purchasedNetatmoPro",
    "defaultMessage": "You previously purchased Netatmo Pro ({date}). It gives you access to a subset of premium features. Subscribe to one of the following offers if you want to have access to all premium features."
  },
  premiumDescription: {
    "id": "common.premiumDescription",
    "defaultMessage": "Premium subscription unlocks many additional features such as advanced weather analysis, chart comparisons, regional forecast models and lots more."
  },
  freeTrialForPeriod: {
    "id": "common.freeTrialForPeriod",
    "defaultMessage": "Free trial for {period} days"
  },
  manageMySubscription: {
    "id": "common.manageMySubscription",
    "defaultMessage": "Manage my subscription"
  },
  restorePurchase: {
    "id": "common.restorePurchase",
    "defaultMessage": "Restore purchase"
  },
  notPurchasedYet: {
    "id": "common.notPurchasedYet",
    "defaultMessage": "It seems this has not been purchased yet."
  },
  billingDetails: {
    "id": "common.billingDetails",
    "defaultMessage": "For free trial offer, you will not be charged if you cancel 24 hours before the free introductory period expires. When the trial is over, you can cancel SmartMixin subscription anytime through your App Store account settings, or it will be automatically renewed. This must be done 24 hours before the end of the subscription period to avoid being charged another fee shown in the button above. Subscription payments will be charged to your App Store account at confirmation of your purchase and upon commencement of each renewal term."
  },
  loading: {
    "id": "common.loading",
    "defaultMessage": "Loading"
  },
  resetZoom: {
    "id": "common.resetZoom",
    "defaultMessage": "Reset Zoom"
  },
  range: {
    "id": "common.range",
    "defaultMessage": "Range"
  },
  averageOverThePeriod: {
    "id": "common.averageOverThePeriod",
    "defaultMessage": "Average over the period"
  },
  sumOverThePeriod: {
    "id": "common.sumOverThePeriod",
    "defaultMessage": "Cumulated over the period"
  },
  average: {
    "id": "common.average",
    "defaultMessage": "Average"
  },
  weatherStation: {
    "id": "common.weatherStation",
    "defaultMessage": "Weather station"
  },
  weatherStations: {
    "id": "common.weatherStations",
    "defaultMessage": "Weather stations"
  },
  selectWeatherForecastProvider: {
    "id": "common.selectWeatherForecastProvider",
    "defaultMessage": "Please choose a weather provider"
  },
  editor: {
    "id": "common.editor",
    "defaultMessage": "Editor"
  },
  meshSize: {
    "id": "common.meshSize",
    "defaultMessage": "Grid size"
  },
  horizon: {
    "id": "common.horizon",
    "defaultMessage": "Horizon"
  },
  horizonValue: {
    "id": "common.horizonValue",
    "defaultMessage": "up to {value} hours"
  },
  frequency: {
    "id": "common.frequency",
    "defaultMessage": "Frequency"
  },
  moreInformation: {
    "id": "common.moreInformation",
    "defaultMessage": "More information"
  },
  timeSelection: {
    "id": "common.timeSelection",
    "defaultMessage": "Time selection"
  },
  comparison: {
    "id": "common.comparison",
    "defaultMessage": "Comparison"
  },
  cannotBeEmpty: {
    "id": "common.cannotBeEmpty",
    "defaultMessage": "This field cannot be empty."
  },
  validEmail: {
    "id": "common.validEmail",
    "defaultMessage": "A valid email address is required."
  },
  passwordUpdated: {
    "id": "common.passwordUpdated",
    "defaultMessage": "Password successfully updated."
  },
  profileUpdated: {
    "id": "common.profileUpdated",
    "defaultMessage": "Profile successfully updated."
  },
  accountDeleted: {
    "id": "common.accountDeleted",
    "defaultMessage": "Your account has been successfully deleted."
  },
  deleteAccount: {
    "id": "common.deleteAccount",
    "defaultMessage": "Delete your account"
  },
  deleteAccountConfirmation: {
    "id": "common.deleteAccountConfirmation",
    "defaultMessage": "Are you sure you want to delete your account? This action is irreversible."
  },
  deleteAccountDescription: {
    "id": "common.deleteAccountDescription",
    "defaultMessage": "This action deletes your account and all your information. There is no going back."
  },
  yes: {
    "id": "common.yes",
    "defaultMessage": "Yes"
  },
  no: {
    "id": "common.no",
    "defaultMessage": "No"
  },
  close: {
    "id": "common.close",
    "defaultMessage": "Close"
  },
  chartView: {
    "id": "common.chartView",
    "defaultMessage": "Chart view"
  },
  calendarView: {
    "id": "common.calendarView",
    "defaultMessage": "Calendar view"
  },
  // Netatmo
  outdatedModule: {
    "id": "common.outdatedModule",
    "defaultMessage": "The data for this module is out of date.",
    "description": "Netatmo"
  },
  noOutdoorModule: {
    "id": "common.noOutdoorModule",
    "defaultMessage": "There is no functional outdoor module for this station."
  },
  outdoor: {
    "id": "common.outdoor",
    "defaultMessage": "Outdoor"
  },
  indoor: {
    "id": "common.indoor",
    "defaultMessage": "Indoor"
  },
  rain: {
    "id": "common.rain",
    "defaultMessage": "Rain"
  },
  wind: {
    "id": "common.wind",
    "defaultMessage": "Wind"
  },
  stationName: {
    "id": "common.stationName",
    "defaultMessage": "Station name"
  },
  location: {
    "id": "common.location",
    "defaultMessage": "Location"
  },
  timezone: {
    "id": "common.timezone",
    "defaultMessage": "Timezone"
  },
  altitude: {
    "id": "common.altitude",
    "defaultMessage": "Altitude"
  },
  serialNumber: {
    "id": "common.serialNumber",
    "defaultMessage": "Serial number"
  },
  firmwareVersion: {
    "id": "common.firmwareVersion",
    "defaultMessage": "Firmware version"
  },
  signalStrength: {
    "id": "common.signalStrength",
    "defaultMessage": "Signal strength"
  },
  batteryLevel: {
    "id": "common.batteryLevel",
    "defaultMessage": "Battery level"
  },
  bad: {
    "id": "common.bad",
    "defaultMessage": "Bad"
  },
  good: {
    "id": "common.good",
    "defaultMessage": "Good"
  },
  lastUpdate: {
    "id": "common.lastUpdate",
    "defaultMessage": "Last update"
  },
  stationInformation: {
    "id": "common.stationInformation",
    "defaultMessage": "Station information"
  },
  dashboard: {
    "id": "common.dashboard",
    "defaultMessage": "Dashboard"
  },
  forecast: {
    "id": "common.forecast",
    "defaultMessage": "Forecast"
  },
  forecastSources: {
    "id": "common.forecastSources",
    "defaultMessage": "Forecast sources"
  },
  charts: {
    "id": "common.charts",
    "defaultMessage": "Charts"
  },
  analysis: {
    "id": "common.analysis",
    "defaultMessage": "Analysis"
  },
  more: {
    "id": "common.more",
    "defaultMessage": "More"
  },
  homeInformation: {
    "id": "common.homeInformation",
    "defaultMessage": "Home information"
  },
  homeName: {
    "id": "common.homeName",
    "defaultMessage": "Home name"
  },
  relay: {
    "id": "common.relay",
    "defaultMessage": "Relay"
  },
  smartThermostat: {
    "id": "common.smartThermostat",
    "defaultMessage": "Smart thermostat"
  },
  smartValve: {
    "id": "common.smartValve",
    "defaultMessage": "Smart valve"
  },
  moduleType: {
    "id": "common.moduleType",
    "defaultMessage": "Module type"
  },
  very_low: {
    "id": "common.very_low",
    "defaultMessage": "Very low"
  },
  low: {
    "id": "common.low",
    "defaultMessage": "Low"
  },
  medium: {
    "id": "common.medium",
    "defaultMessage": "Medium"
  },
  high: {
    "id": "common.high",
    "defaultMessage": "High"
  },
  full: {
    "id": "common.full",
    "defaultMessage": "Full"
  },
  wifiStrength: {
    "id": "common.wifiStrength",
    "defaultMessage": "WiFi strength"
  },
  rooms: {
    "id": "common.rooms",
    "defaultMessage": "Rooms"
  },
  room: {
    "id": "common.room",
    "defaultMessage": "Room"
  },
  untilTime: {
    "id": "common.untilTime",
    "defaultMessage": "Until {time}"
  },
  hg: {
    "id": "common.hg",
    "defaultMessage": "Frost guard"
  },
  away: {
    "id": "common.away",
    "defaultMessage": "Away"
  },
  edit: {
    "id": "common.edit",
    "defaultMessage": "Edit"
  },
  add: {
    "id": "common.add",
    "defaultMessage": "Add"
  },
  "delete": {
    "id": "common.delete",
    "defaultMessage": "Delete"
  },
  cancel: {
    "id": "common.cancel",
    "defaultMessage": "Cancel"
  },
  validate: {
    "id": "common.validate",
    "defaultMessage": "Validate"
  },
  untilChanged: {
    "id": "common.untilChanged",
    "defaultMessage": "Until changed"
  },
  manualSetpointUntil: {
    "id": "common.manualSetpointUntil",
    "defaultMessage": "Manual setpoint until"
  },
  manualBoost: {
    "id": "common.manualBoost",
    "defaultMessage": "Manual boost"
  },
  whenBackHome: {
    "id": "common.whenBackHome",
    "defaultMessage": "When will you be back home?"
  },
  iDontKnowYet: {
    "id": "common.iDontKnowYet",
    "defaultMessage": "I don't know yet"
  },
  boilerOn: {
    "id": "common.boilerOn",
    "defaultMessage": "Boiler ON"
  },
  noDataForThisPeriod: {
    "id": "common.noDataForThisPeriod",
    "defaultMessage": "No data for this period"
  },
  upgradeRequired: {
    "id": "common.upgradeRequired",
    "defaultMessage": "An upgrade of your application is required. Visit the App Store to upgrade."
  },
  upgrade: {
    "id": "common.upgrade",
    "defaultMessage": "Upgrade"
  },
  noNetatmoWeatherStationYet: {
    "id": "common.noNetatmoWeatherStationYet",
    "defaultMessage": "You don't have a Netatmo weather station yet."
  },
  visitNetatmoWebsite: {
    "id": "common.visitNetatmoWebsite",
    "defaultMessage": "Visit Netatmo website"
  },
  accountOnHold: {
    "id": "common.accountOnHold",
    "defaultMessage": "Your account has been placed on hold. Click the link for further instructions."
  },
  manageAccount: {
    "id": "common.manageAccount",
    "defaultMessage": "Manage account"
  },
  noThermostatYet: {
    "id": "common.noThermostatYet",
    "defaultMessage": "You dont' have a thermostat yet."
  },
  home: {
    "id": "common.home",
    "defaultMessage": "Home"
  },
  welcome: {
    "id": "common.welcome",
    "defaultMessage": "Welcome to SmartMixin!"
  },
  homeIntroduction: {
    "id": "common.homeIntroduction",
    "defaultMessage": "Start connecting your external accounts to enjoy SmartMixin features."
  },
  weatherMap: {
    "id": "common.weatherMap",
    "defaultMessage": "Weathermap"
  },
  filterStations: {
    "id": "common.filterStations",
    "defaultMessage": "Filter stations"
  },
  filterStationDescription: {
    "id": "common.filterStationDescription",
    "defaultMessage": "Do not display stations with unreliable measures"
  },
  rainfallMeasurement: {
    "id": "common.rainfallMeasurement",
    "defaultMessage": "Rainfall measurement"
  },
  windMeasurement: {
    "id": "common.windMeasurement",
    "defaultMessage": "Wind measurement"
  },
  outdoorTemperature: {
    "id": "common.outdoorTemperature",
    "defaultMessage": "Outdoor temperature"
  },
  share: {
    "id": "common.share",
    "defaultMessage": "Share"
  },
  shareYourWeather: {
    "id": "common.shareYourWeather",
    "defaultMessage": "Share your weather"
  },
  noWeatherStationYet: {
    "id": "common.noWeatherStationYet",
    "defaultMessage": "You don't have a weather station yet."
  },
  removeFromFavorites: {
    "id": "common.removeFromFavorites",
    "defaultMessage": "Remove from favorites"
  },
  addToFavorites: {
    "id": "common.addToFavorites",
    "defaultMessage": "Add to favorites"
  },
  currentObservations: {
    "id": "common.currentObservations",
    "defaultMessage": "Current observations"
  },
  nextHours: {
    "id": "common.nextHours",
    "defaultMessage": "Next hours"
  },
  dailyForecast: {
    "id": "common.dailyForecast",
    "defaultMessage": "Daily forecast"
  },
  rainRadar: {
    "id": "common.rainRadar",
    "defaultMessage": "Rain radar"
  },
  details: {
    "id": "common.details",
    "defaultMessage": "Details"
  },
  favoriteStations: {
    "id": "common.favoriteStations",
    "defaultMessage": "Favorite stations"
  },
  recentStations: {
    "id": "common.recentStations",
    "defaultMessage": "Recent stations"
  },
  noWeatherStation: {
    "id": "common.noWeatherStation",
    "defaultMessage": "No weather station"
  },
  locations: {
    "id": "common.locations",
    "defaultMessage": "Locations"
  },
  searchForLocation: {
    "id": "common.searchForLocation",
    "defaultMessage": "Search for a location"
  },
  aroundMe: {
    "id": "common.aroundMe",
    "defaultMessage": "Around me"
  },
  stationRemovedFromFavorites: {
    "id": "common.stationRemovedFromFavorites",
    "defaultMessage": "Station removed from favorites"
  },
  stationAddedToFavorites: {
    "id": "common.stationAddedToFavorites",
    "defaultMessage": "Station added to favorites"
  },
  searchForWeatherStation: {
    "id": "common.searchForWeatherStation",
    "defaultMessage": "Search for a weather station"
  },
  shareOutdoorMeasures: {
    "id": "common.shareOutdoorMeasures",
    "defaultMessage": "Share your outdoor measures"
  },
  shareOutdoorMeasuresDescription: {
    "id": "common.shareOutdoorMeasuresDescription",
    "defaultMessage": "Participate in the SmartMixin community by making your outdoor measures visible to others. Indoor measures will never be shared."
  },
  customizedStationName: {
    "id": "common.customizedStationName",
    "defaultMessage": "Customized station name"
  },
  stationType: {
    "id": "common.stationType",
    "defaultMessage": "Station type"
  },
  addYourOwnStation: {
    "id": "common.addYourOwnStation",
    "defaultMessage": "Add your own station"
  },
  weatherForecastModels: {
    "id": "common.weatherForecastModels",
    "defaultMessage": "Weather forecast models"
  },
  forecastModelComparison: {
    "id": "common.forecastModelComparison",
    "defaultMessage": "Forecast model comparison"
  },
  forecastComparisonDescription: {
    "id": "common.forecastComparisonDescription",
    "defaultMessage": "Easily compare forecast model outputs from several sources"
  },
  addAStation: {
    "id": "common.addAStation",
    "defaultMessage": "Add a station"
  },
  measureToDisplay: {
    "id": "common.measureToDisplay",
    "defaultMessage": "Measure to display"
  },
  renameSensors: {
    "id": "common.renameSensors",
    "defaultMessage": "Rename sensors"
  },
  selectStationForComparison: {
    "id": "common.selectStationForComparison",
    "defaultMessage": "Select a station to compare with"
  },
  stationComparison: {
    "id": "common.stationComparison",
    "defaultMessage": "Station comparison"
  },
  stationComparisonDescription: {
    "id": "common.stationComparisonDescription",
    "defaultMessage": "Compare historical weather data with another station"
  },
  temperatureSummary: {
    "id": "common.temperatureSummary",
    "defaultMessage": "Temperature summary"
  },
  rainSummary: {
    "id": "common.rainSummary",
    "defaultMessage": "Rain summary"
  },
  windSummary: {
    "id": "common.windSummary",
    "defaultMessage": "Wind summary"
  },
  pressureSummary: {
    "id": "common.pressureSummary",
    "defaultMessage": "Pressure summary"
  },
  currentDay: {
    "id": "common.currentDay",
    "defaultMessage": "Current day"
  },
  monthTotal: {
    "id": "common.monthTotal",
    "defaultMessage": "Month total"
  },
  yearToDate: {
    "id": "common.yearToDate",
    "defaultMessage": "Year to Date"
  },
  rainEvents: {
    "id": "common.rainEvents",
    "defaultMessage": "Rain events"
  },
  currentRate: {
    "id": "common.currentRate",
    "defaultMessage": "Current rate"
  },
  currentRainEvent: {
    "id": "common.currentRainEvent",
    "defaultMessage": "Current rain event"
  },
  lastRainEvent: {
    "id": "common.lastRainEvent",
    "defaultMessage": "Last rain event"
  },
  startTime: {
    "id": "common.startTime",
    "defaultMessage": "Start time"
  },
  endTime: {
    "id": "common.endTime",
    "defaultMessage": "End time"
  },
  totalDuration: {
    "id": "common.totalDuration",
    "defaultMessage": "Total duration"
  },
  weatherflowNCRain: {
    "id": "common.weatherflowNCRain",
    "defaultMessage": "NC Rain (Nearcast Rain)"
  },
  weatherflowNCRainDescription: {
    "id": "common.weatherflowNCRainDescription",
    "defaultMessage": "NC Rain is an additional data source provided via the Tempest Weather System, powered by Nearcast Technology. NC Rain data is an estimate of the average rainfall accumulation around your Tempest at the neighborhood level"
  }
});